<template>
  <div>
    <div class="mt-3" v-if="carregaTipo.inclusao">
      <div class="titlePage mb-3">Inclusão de Gabaritos e Provas</div>
      <fcc-table
        striped
        hover
        :fields="fieldsInclusao"
        :items="lstInclusao"
        responsive
        @row-selected="atualizaSelecionadoIncluidos"
        :mostrarQuantidade="false"
      />
      <fcc-button @click="incluirGabarito()" v-if="selecionadosIncluidos.length"
        >Incluir</fcc-button
      >
    </div>
    <div class="mt-4" v-if="carregaTipo.alteracao">
      <div class="titlePage mb-3">Alteração de Gabaritos e Provas</div>
      <fcc-table
        striped
        hover
        :fields="fieldsAlteracao"
        :items="lstAlteracao"
        responsive
        @row-selected="atualizaSelecionadoAlterados"
        :mostrarQuantidade="false"
      />
      <fcc-button @click="alterarGabarito()" v-if="selecionadosAlterados.length"
        >Alterar</fcc-button
      >
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      selecionadosIncluidos: [],
      selecionadosAlterados: [],
      fieldsAlteracao: [
        {
          key: 'rowSelect',
          sortable: false,
          type: 'rowSelect',
          selectDisabled: true,
          campoDisabled: {
            campo: 'alteracaorealizada',
            valor: 'SIM'
          }
        },
        { key: 'numpedido', label: 'Núm. Pedido', sortable: true },
        { key: 'folha', label: 'Folha' },
        {
          key: 'tipogabaritoantes',
          label: 'Tipo Anterior',
          sortable: true,
          tdClass: 'text-center'
        },
        {
          key: 'tipogabaritoapos',
          label: 'Tipo Após',
          sortable: true,
          tdClass: 'text-center'
        },
        { key: 'tecnico', label: 'Técnico' },
        { key: 'databusca', label: 'Data de Busca', sortable: true },
        {
          key: 'alteracaorealizada',
          label: 'Alteração Realizada',
          sortable: true
        },
        { key: 'dataalteracao', label: 'Data de Alteração', sortable: true }
      ],
      rowSelectSelected: {},
      fieldsInclusao: [
        {
          key: 'rowSelect',
          sortable: false,
          type: 'rowSelect',
          selectDisabled: true,
          campoDisabled: {
            campo: 'inclusaorealizada',
            valor: 'SIM'
          }
        },
        { key: 'idtipogabaritoprova', label: 'Id Tipo Gabarito', sortable: true },
        { key: 'numpedido', label: 'Núm. Pedido', sortable: true },
        { key: 'arquivoprova', label: 'Arquivo da Prova', sortable: true },
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'databusca', label: 'Data de Busca', sortable: true },
        {
          key: 'inclusaorealizada',
          label: 'Inclusão Realizada',
          sortable: true
        },
        { key: 'datainclusao', label: 'Data de Inclusão', sortable: true }
      ],
      baseUrlPublicacao: ''
    }
  },
  beforeMount() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
  },
  props: {
    idNotificacao: String,
    lstInclusao: Array,
    lstAlteracao: Array,
    carregaTipo: Object
  },
  methods: {
    incluirGabarito() {
      const inclui = []
      this.selecionadosIncluidos.forEach((element) => {
        inclui.push(element.idinclusaogabarito)
      })
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + `PublicacaoGabarito/InclusaoGabaritoProva`,
          inclui,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.selecionadosIncluidos = response.data
          this.$emit('listarInclusao')
        })
        .catch(this.setErrorSystem)
    },
    alterarGabarito() {
      const alterar = []
      this.selecionadosAlterados.forEach((element) => {
        alterar.push(element.idalteracaogabarito)
      })
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + `PublicacaoGabarito/AlteracaoTipoGabaritoProva`,
          alterar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.selecionadosIncluidos = response.data
          this.$emit('listarAlteracao')
        })
        .catch(this.setErrorSystem)
    },
    atualizaSelecionadoIncluidos(items) {
      this.selecionadosIncluidos = items
    },
    atualizaSelecionadoAlterados(items) {
      this.selecionadosAlterados = items
    }
  }
}
</script>